import { useState, useEffect } from 'react';
// components
import Dialog from '../../../components/dialog';
import Pagination from '../../../components/pagination';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// assets
import { ReactComponent as Search } from '../../../assets/form/search.svg';
// styles
import { SearchInput, Message, ButtonWrapper, PrimaryButton, TertiaryButton } from '../../../styles';

// ----------------------------------------------------------------------

interface Props {
  rows: {
    organizationId: string;
    name: string;
    description: string;
  }[];
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  displayName: {
    displayNameId: any;
    category: string;
  };
  setDisplayName: React.Dispatch<React.SetStateAction<{
    displayNameId: any;
    category: string;
  }>>;
  setName: React.Dispatch<React.SetStateAction<string>>;
  page: number;
  pages: number;
  size: number;
  handlePage: (value: number) => void;
  handleSearch: () => void;
};

// ----------------------------------------------------------------------

export default function FormDialog({ rows, setName, page, pages, size, handlePage, handleSearch, setVisible, displayName, setDisplayName }: Props) {

  const [ selected, setSelected ] = useState(displayName);
  const [ message, setMessage ] = useState(null);

  const handleClose = () => setVisible(false);

  const handleSelected = () => {
    if ( !selected.displayNameId ) return setMessage('표시명을 선택해 주세요.');
    setDisplayName(selected);
    handleClose();
  };

  return (
    <Dialog
      title='IoT 장비 그룹 검색'
      handleClose={handleClose}
    >
      <SearchInput>
        <input type='text' placeholder='IoT 장비 그룹을 입력하세요.' onChange={(event) => setName(event.target.value)} onKeyDown={(event) => { if(event.key === 'Enter') handleSearch() }} />
        <Search />
      </SearchInput>

      <DataGrid
        dataSource={rows}
        noDataText=''
        columnAutoWidth={true}
        paging={{enabled: false}}
        dataRowRender={({data}) => <TableRow row={data} selected={selected} setSelected={setSelected} />}
      >
        <Column caption='' dataField='displayNameId' />
        <Column caption='분류' dataField='category' alignment='center' />
        <Column caption='수온' dataField='waterTemperature' alignment='center' />
        <Column caption='수온 단위' dataField='waterTemperatureUnit' alignment='center' />
      </DataGrid>
      <Pagination page={page} pages={pages} size={size} handlePage={handlePage} />

      <Message $visible={message ? true : false}>{ message }</Message>

      <ButtonWrapper>
        <PrimaryButton onClick={() => handleSelected()}>선택</PrimaryButton>
        <TertiaryButton type='button' onClick={() => handleClose()}>취소</TertiaryButton>
      </ButtonWrapper>
    </Dialog>
  );
}

// ----------------------------------------------------------------------

interface RowProps {
  row: {
    displayNameId: string;
    category: string;
    waterTemperature: string;
    waterTemperatureUnit: number;
  };
  selected: {
    displayNameId: any;
    category: string;
  };
  setSelected: React.Dispatch<React.SetStateAction<{
    displayNameId: any;
    category: string;
  }>>;
};

// ----------------------------------------------------------------------

function TableRow({ row, selected, setSelected }: RowProps){
  return (
    <tr>
      <td>
        <label htmlFor={`checkbox${row.displayNameId}`}>
        <input type='radio' id={`checkbox${row.displayNameId}`} name='organization' checked={selected.displayNameId === row.displayNameId ? true : false} onChange={() => setSelected({displayNameId: row.displayNameId, category: row.category})} />
        </label>
      </td>
      <td><label htmlFor={`checkbox${row.displayNameId}`}>{row.category}</label></td>
      <td><label htmlFor={`checkbox${row.displayNameId}`}>{row.waterTemperature}</label></td>
      <td><label htmlFor={`checkbox${row.displayNameId}`}>{row.waterTemperatureUnit}</label></td>
    </tr>
  );
}